<template>
  <el-card class="box-card full-screen">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('date')">
          <el-date-picker
            v-model="queryForm.date"
            type="daterange"
            range-separator="~"
            :start-placeholder="$t('startDate')"
            :end-placeholder="$t('endDate')"
            value-format="yyyy-MM-dd"
            size="small"
            unlink-panels
            :clearable="true"
            :picker-options="pickerOptions0"
            @change="changeDate"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          v-if="loginInfo.orgType == 1"
          :label="$t('affiliationOrg')"
        >
          <el-select
            v-model="queryForm.orgInfoId"
            :placeholder="$t('all')"
            filterable
            size="small"
          >
            <el-option :label="$t('all')" value=""></el-option>
            <el-option
              v-for="(t, i) in orgList"
              :key="i"
              :label="t.name + ' -- ' + t.orgInfoCode"
              :value="t.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="loginInfo.orgType == 1" :label="$t('coordination')">
          <el-select
            v-model="queryForm.regionId"
            :placeholder="$t('all')"
            filterable
            size="small"
          >
            <el-option :label="$t('all')" value=""></el-option>
            <el-option
              v-for="(t, i) in regionList"
              :key="i"
              :label="t.name"
              :value="t.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isloading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`,
      }"
    >
      <el-table
        :data="tableData.records"
        v-loading="isloading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column
          align="center"
          :label="$t('Inflows')"
          min-width="160"
          class-name="multiple-header-intervals"
        >
          <el-table-column
            prop="createTime"
            :label="$t('creationTime')"
            min-width="160"
          >
            <template slot-scope="scope">{{
              $manba(scope.row.createTime).format("ymdhms")
            }}</template>
          </el-table-column>

          <el-table-column
            prop="orgName"
            :label="$t('operateOrg')"
            min-width="160"
          >
            <template slot-scope="scope">
              {{ scope.row.orgName }} ({{ scope.row.orgInfoCode }})</template
            >
          </el-table-column>
          <el-table-column
            prop="initialAmount"
            :label="$t('Initial amount')"
            min-width="160"
          >
            <template slot-scope="scope"
              ><span class="franc">₣</span
              >{{ scope.row.initialAmount }}</template
            >
          </el-table-column>
          <el-table-column
            prop="totalAmountRemittance"
            :label="$t('totalRemittance')"
            min-width="160"
          >
            <template slot-scope="scope"
              ><span class="franc">₣</span
              >{{
                scope.row.totalAmountRemittance
                  .replace("-", "")
                  .split(".")[0]
                  .formatMoney(0)
              }}</template
            >
          </el-table-column>
          <el-table-column
            prop="totalBankWithdrawal"
            :label="$t('Total bank withdrawal')"
            min-width="160"
          >
            <template slot-scope="scope"
              ><span class="franc">₣</span
              >{{ scope.row.totalBankWithdrawal }}</template
            >
          </el-table-column>
          <el-table-column
            prop="totalCashToReceive"
            :label="$t('Total cashToReceive')"
            min-width="160"
          >
            <template slot-scope="scope"
              ><span class="franc">₣</span
              >{{ scope.row.totalCashToReceive || 0 }}</template
            >
          </el-table-column>
          <el-table-column
            prop="totalOthersCashToReceive"
            :label="$t('Total others cashToReceive')"
            min-width="160"
            class-name="multiple-header-intervals"
          >
            <template slot-scope="scope"
              ><span class="franc">₣</span
              >{{ scope.row.totalOthersCashToReceive || 0 }}</template
            >
          </el-table-column>
        </el-table-column>
        <el-table-column min-width="160" class-name="multiple-header-intervals">
          <template slot-scope=""></template>
        </el-table-column>

        <el-table-column align="center" :label="$t('Outflows')" min-width="160">
          <el-table-column
            prop="totalWithdrawal"
            :label="$t('Total withdrawal')"
            min-width="160"
          >
            <template slot-scope="scope"
              ><span class="franc">₣</span>
              {{
                parseFloat(scope.row.totalWithdrawal || 0)
                  .toString()
                  .replace("-", "")
                  .split(".")[0]
                  .formatMoney(0)
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="totalCashLending"
            :label="$t('Total cashLending')"
            min-width="160"
          >
            <template slot-scope="scope"
              ><span class="franc">₣</span>
              {{ scope.row.totalCashLending || 0 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="totalExpenses"
            :label="$t('Total expenses')"
            min-width="160"
          >
            <template slot-scope="scope"
              ><span class="franc">₣</span
              >{{ scope.row.totalExpenses || 0 }}</template
            >
          </el-table-column>
          <el-table-column
            prop="totalBankDeposit"
            :label="$t('Total bank deposit')"
            min-width="160"
          >
            <template slot-scope="scope"
              ><span class="franc">₣</span
              >{{ scope.row.totalBankDeposit || 0 }}</template
            >
          </el-table-column>
          <el-table-column
            prop="totalRemovedRemittance"
            :label="$t('Total removed remittance')"
            min-width="160"
          >
            <template slot-scope="scope"
              ><span class="franc">₣</span
              >{{ scope.row.totalRemovedRemittance || 0 }}</template
            >
          </el-table-column>
          <el-table-column
            prop="totalCancelRemittance"
            :label="$t('Total cancel remittance')"
            min-width="160"
          >
            <template slot-scope="scope"
              ><span class="franc">₣</span
              >{{ scope.row.totalCancelRemittance || 0 }}</template
            >
          </el-table-column>

          <el-table-column
            prop="regularizationAmount"
            :label="$t('Regularization amount')"
            min-width="160"
          >
            <template slot-scope="scope"
              ><span class="franc">₣</span
              >{{ scope.row.regularizationAmount || 0 }}</template
            >
          </el-table-column>
          <el-table-column
            prop="virtualAmount"
            :label="$t('Virtual amount')"
            min-width="160"
          >
            <template slot-scope="scope"
              ><span class="franc">₣</span
              >{{ scope.row.virtualAmount || 0 }}</template
            >
          </el-table-column>
          <el-table-column
            prop="realsAmount"
            :label="$t('Reals amount')"
            min-width="160"
          >
            <template slot-scope="scope"
              ><span class="franc">₣</span
              >{{ scope.row.realsAmount || 0 }}</template
            >
          </el-table-column>
          <el-table-column prop="gap" :label="$t('GAP')" min-width="160">
            <template slot-scope="scope"
              ><span class="franc">₣</span>{{ scope.row.gap || 0 }}</template
            >
          </el-table-column>
          <el-table-column min-width="160">
            <template slot-scope=""></template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="tableData.total"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />
  </el-card>
</template>

<script>
import org from "@/api/org";
import transactionInfo from "@/api/transactionInfo";
import country from "@/api/country";

export default {
  name: "remittanceList",
  data() {
    return {
      queryForm: { customerType: 1 },
      // queryForm: { queryObject: 1 },
      queryTableHeight: String,
      orgList: [],
      regionList: [],
      tableData: {},
      pageSize: 20,
      currentPage: 1,
      isloading: false,

      editVisible: false,
      editForm: {},
      surplusTime: 0,
      pickerOptions0: {
        onPick: ({ maxDate, minDate }) => {
          this.minDate = minDate;
          this.maxDate = maxDate;
        },
        disabledDate: (time) => {
          let today = 3 * 30 * 24 * 3600 * 1000;
          if (this.minDate) {
            return (
              time.getTime() > Date.now() ||
              time > new Date(this.minDate.getTime() + today) ||
              time < new Date(this.minDate.getTime() - today)
            );
          }
          return time.getTime() > Date.now();
        },
      },
    };
  },
  computed: {
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },
    cascader() {
      return this.$store.state.format.cascader;
    },
    countryTree() {
      return this.$store.state.globalParameter.countryTree;
    },
    countryList() {
      return this.$store.state.globalParameter.countryList;
    },
    rules() {
      return {};
    },
  },
  watch: {
    "queryForm.date"(newVal) {
      if (newVal && newVal.length > 0) {
        this.queryForm.startTime = this.queryForm.date[0];
        this.queryForm.endTime = this.queryForm.date[1];
      } else {
        this.queryForm.startTime = undefined;
        this.queryForm.endTime = undefined;
      }
    },
  },

  methods: {
    getList() {
      let _this = this;
      _this.tableData.records = [];
      _this.isLoading = true;
      let params = JSON.parse(JSON.stringify(_this.queryForm));
      if (params.date && params.date.length > 0) {
        params.startTime = _this.$manba(params.date[0]).format("ymd");
        params.endTime = _this.$manba(params.date[1]).format("ymd");
      } else {
        params.startTime = undefined;
        params.endTime = undefined;
      }
      delete params.date;

      transactionInfo.pageClosingManagementList({
        param: {
          current: _this.currentPage,
          size: _this.pageSize,
          ..._this.queryForm,
        },
        success: (res) => {
          _this.isLoading = false;
          _this.tableData = res.data || {};
        },
      });
      _this.isLoading = false;
    },
    getOrgList() {
      let _this = this;
      org.getOrgInfoPage({
        param: { current: 1, size: 10000 },
        success: (res) => {
          if (res.data) _this.orgList = res.data.records;
        },
      });
    },
    getAllRegionList() {
      let _this = this;
      country.getAllRegionList({
        param: {},
        success: (res) => {
          if (res.data) _this.regionList = res.data;
        },
      });
    },
    changeDate(e) {
      if (e === null) {
        this.minDate = "";
        this.maxDate = "";
        this.pickerBeginDateBefore = {
          disabledDate: (time) => {
            let three = 3 * 30 * 24 * 3600 * 1000;
            if (this.minDate) {
              return (
                time.getTime() > Date.now() ||
                time > new Date(this.minDate.getTime() + three) ||
                time < new Date(this.minDate.getTime() - three)
              );
            }
            return time.getTime() > Date.now();
          },
        };
      }
    },
    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    getSmsVerification() {
      let _this = this;
      transactionInfo.sendVerificationCode({
        param: { phone: this.editForm.remitterPhone },
        success: function(res) {
          if (res.code != 200) {
            _this.$message.warning(_this.$t(res.msg));
            return;
          }
          _this.surplusTime = 60;
          let interval = setInterval(() => {
            _this.surplusTime -= 1;
            if (_this.surplusTime === 0) clearInterval(interval);
          }, 1000);
          _this.$message.success(
            _this.$t("SMS verification code sent successfully") +
              "，" +
              _this.$t("Verification code Receiving number") +
              _this.editForm.remitterPhone
          );
        },
      });
    },
    visibleEdit(row) {
      this.editForm = row;
      this.editForm.country_region_city = [
        Number(row.country),
        Number(row.region),
        Number(row.city),
      ];
      this.editVisible = true;
    },
    updateSubmit(refName) {
      let _this = this;
      this.$refs[refName].validate(function(valid) {
        if (!valid) return false;
        let update = {
          payeeDetailsId: _this.editForm.payeeDetailsId,
          remitterPhone: _this.editForm.remitterPhone,
          surname: _this.editForm.payeeSurname,
          name: _this.editForm.payeeName,
          phone: _this.editForm.payeePhone,
          idCard: _this.editForm.payeeIdCard,
          country: _this.editForm.country_region_city[0],
          region: _this.editForm.country_region_city[1],
          city: _this.editForm.country_region_city[2],
          smsCode: _this.editForm.smsCode,
        };

        transactionInfo.updatePayeeInfo({
          param: update,
          success: (res) => {
            if (res.code == 200) {
              _this.$message.success(_this.$t("operateSuccessfully"));
              _this.editVisible = false;
              _this.getList();
            } else
              _this.$message.warning(_this.$t(res.msg || "operationFailure"));
          },
        });
      });
    },
  },
  mounted() {
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";

    this.getList();

    this.getAllRegionList();

    this.getOrgList();
  },
};
</script>
<style lang="less"></style>
